import React from 'react';
import loadable from '@loadable/component';
import { LoadingBar } from '@autobest-ui/components';

export default loader =>
  loadable(loader, {
    fallback: <LoadingBar />
  });
